import { Injectable } from '@angular/core';
import { MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class IosAppNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor() {
    super(
      'IOS_APP',
      _('a11y.link.to_apple_store'),
      _('general.link_to_apple_store'),
      _('a11y.link.to_apple_store'),
      'STORE_ENTRYS',
      'assets/images/apple_store_badge.svg',
    );
  }
}
